// imports
import React, { createContext, useContext } from 'react';
import { TravelCurrencyCode } from '@graphql/generated';

interface AccommodationCurrencyContextValue {
  readonly eventCurrency?: TravelCurrencyCode | null;
}

const AccommodationCurrencyContext = createContext<AccommodationCurrencyContextValue | undefined>(undefined);

export const AccommodationCurrencyProvider: React.FC<{
  readonly eventCurrency?: TravelCurrencyCode | null;
  children: React.ReactNode;
}> = ({ eventCurrency, children }) => {
  return <AccommodationCurrencyContext.Provider value={{ eventCurrency }}>{children}</AccommodationCurrencyContext.Provider>;
};

export const useAccommodationCurrency = (): TravelCurrencyCode | null | undefined => {
  const context = useContext(AccommodationCurrencyContext);
  // Return null/undefined when event currency is not set, allowing callers to fall back to user's locale currency
  return context?.eventCurrency;
};
